import { c as _c } from "react/compiler-runtime";
import type { FC } from "react";
import { PlateContent, type PlateContentProps } from "@platejs/core/react";
import type { NoteBlock } from "@vita-learning/types";
interface EditorProps extends Omit<PlateContentProps, "content"> {
  readonly content?: NoteBlock[];
}
export const Editor: FC<EditorProps> = t0 => {
  const $ = _c(13);
  let content;
  let props;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      content,
      readOnly: t1,
      style: t2,
      placeholder: t3,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = content;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    content = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const readOnly = t1 === undefined ? !content : t1;
  let t4;
  if ($[6] !== t2) {
    t4 = t2 === undefined ? {
      outline: "none",
      overflowX: "hidden",
      overflowY: "auto",
      height: "100%",
      padding: "1rem 2rem 0"
    } : t2;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const style = t4;
  const placeholder = t3 === undefined ? !content ? "Select a note to edit..." : undefined : t3;
  let t5;
  if ($[8] !== placeholder || $[9] !== props || $[10] !== readOnly || $[11] !== style) {
    t5 = <PlateContent {...props} style={style} placeholder={placeholder} readOnly={readOnly} />;
    $[8] = placeholder;
    $[9] = props;
    $[10] = readOnly;
    $[11] = style;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};